import Config from '../../../config/Config'
import { mergeMap, map, catchError, withLatestFrom } from 'rxjs/operators'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { headersSelector } from '../../auth/selectors'
import * as actions from './actions'
import { ofType } from 'redux-observable'

/**
 * @typedef CreateContentDiscoveryCampaign
 * @property {string} channel - channel the campaign is being created for i.e. twitter, facebook, etc.
 * @property {number} contentDiscoveryId - id of content discovery item to use when creating the campaign
 * @property {number} retailerId - id of the retailer to associate the campaign with
 * @link http://api.promoboxx.com/docs/V2/content_discovery/create.html
 */
export const createContentDiscoveryCampaign = (action$, state$) => {
  return action$.pipe(
    ofType(actions.CREATE_CONTENT_DISCOVERY_CAMPAIGN),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const headers = headersSelector(state)
      const { contentDiscoveryId, retailerId } = action.payload

      if (!headers) {
        throw new Error('Bad or Non-existent auth headers')
      }

      if (!retailerId) {
        throw new Error('payload.retailerId is required')
      }

      if (!contentDiscoveryId) {
        throw new Error('payload.contentDiscoveryId is required')
      }

      const settings = {
        method: 'POST',
        responseType: 'json',
        headers,
        url: `${Config.API_BASE}/v2/retailers/${retailerId}/content_discovery/${contentDiscoveryId}/campaign`,
      }
      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.CREATE_CONTENT_DISCOVERY_CAMPAIGN_FULFILLED,
            payload: {
              response: {
                creativePath: payload.response.creative_path,
                retailerId,
              },
            },
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.CREATE_CONTENT_DISCOVERY_CAMPAIGN_REJECTED,
            payload: payload.response,
          })
        }),
      )
    }),
    catchError((payload) => {
      return of({
        type: actions.CREATE_CONTENT_DISCOVERY_CAMPAIGN_REJECTED,
        payload,
      })
    }),
  )
}
